import { Link } from "react-router"

import { type FCC } from "@forento/ui/types/react"
import { cn } from "@forento/ui/utilities/tailwind"

type ButtonProps = {
	type?: "button" | "submit"
	onClick?(): void
	color: "green" | "purple" | "red"
	disabled?: boolean
	className?: string
}
const Button: FCC<ButtonProps> = ({ type = "button", onClick, color, disabled, className, children }) => (
	<button
		type={type}
		onClick={onClick}
		disabled={disabled}
		className={cn(
			"flex transform items-center gap-2 rounded-lg bg-gradient-to-r px-4 py-2 text-sm font-medium text-white shadow-lg transition-all duration-200 not-disabled:cursor-pointer hover:-translate-y-0.5 hover:shadow-xl disabled:transform-none disabled:opacity-50",
			color === "green" && "from-green-600 to-green-700 hover:from-green-700 hover:to-green-800",
			color === "purple" && "from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800",
			color === "red" && "bg-red-600/90 hover:bg-red-700",
			className,
		)}
	>
		{children}
	</button>
)

type SecondaryButtonProps = { onClick(): void; className?: string }
export const SecondaryButton: FCC<SecondaryButtonProps> = ({ onClick, className, children }) => (
	<button
		type="button"
		onClick={onClick}
		className={cn(
			"cursor-pointer rounded-lg py-2 text-sm font-medium text-slate-500 transition-colors hover:text-slate-700",
			className,
		)}
	>
		{children}
	</button>
)

type ImageButtonProps = { onClick(): void; danger?: boolean; className?: string }
export const ImageButton: FCC<ImageButtonProps> = ({ onClick, danger, className, children }) => (
	<button
		type="button"
		onClick={onClick}
		className={cn(
			"flex cursor-pointer items-center gap-1.5 rounded px-3 py-1 text-sm font-medium text-white opacity-0 transition-opacity group-hover:opacity-100",
			danger ? "bg-red-600/90 hover:bg-red-700" : "bg-black/70 hover:bg-black/80",
			className,
		)}
	>
		{children}
	</button>
)

type ButtonLinkProps = {
	to: string
	color: "green" | "purple"
	className?: string
}
export const ButtonLink: FCC<ButtonLinkProps> = ({ to, color, className, children }) => (
	<Link
		to={to}
		className={cn(
			"flex transform items-center gap-2 rounded-lg bg-gradient-to-r px-4 py-2 text-sm font-medium text-white shadow-lg transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl",
			color === "green" && "from-green-600 to-green-700 hover:from-green-700 hover:to-green-800",
			color === "purple" && "from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800",
			className,
		)}
	>
		{children}
	</Link>
)

export default Button
